import { useEffect, useState } from "react"

export const useResize = ()=>{
    const [size, setSize] = useState({
        width: window.innerWidth, 
        height: window.innerHeight
    });

    useEffect(()=>{
        const handler = ()=>{
            setSize({
                width: window.innerWidth, 
                height: window.innerHeight
            });
        };
        window.addEventListener('resize', handler);
        return ()=> window.removeEventListener('resize', handler);
    }, []);
    
    return size;
}